export default __webpack_public_path__ + "static/media/M13.f9815acc.svg";